export var UNKNOWN_INDICATOR = "N/A";
